import script from "./CommonButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonButton.vue?vue&type=script&lang=ts&setup=true"

import "./CommonButton.vue?vue&type=style&index=0&id=18017b7c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18017b7c"]])

export default __exports__